/**
 * @module app.bdc.reports.exportWebTillCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ExportWebTillCtrl(
        $scope,
        $rootScope,
        reportRoutingService,
        orderService,
        userService,
        marketService,
        exportService,
        pricesService
    ) {
        var self = {};

        self.rds = $rootScope.user;
        self.drv = $rootScope.parent;

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.orders = $rootScope.orders;
        self.reportRouting = reportRoutingService;
        self.marketService = marketService;
        self.exportService = exportService;
        self.pricesService = pricesService;

        /**
         * Get date fr format
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getDate = function getDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getMonthNumberDateSignature = function getMonthNumberDateSignature(date) {
            return date ? moment(date).format('M') : date;
        };

        /**
         * Get date installation
         * @param {String} date
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation(date) {
            return date
                ? moment(date, 'YYYY-MM-DD')
                    .format('MMMM YYYY')
                    .toUpperCase()
                : null;
        };

        /**
         * Get RDS to display
         * @param  {String} rdsRef
         * @return {String}
         */
        self.getRDS = function getRDS(rdsRef) {
            var rds = userService.findPerson(rdsRef);
            return rds ? rds.user.firstname + ' ' + rds.user.lastname : rdsRef;
        };

        /**
         * Get DRV to display
         * @param  {String} drvRef
         * @return {String}
         */
        self.getDRV = function getDRV(drvRef) {
            var drv = userService.findPerson(drvRef);
            return drv ? drv.user.firstname + ' ' + drv.user.lastname : drvRef;
        };

        self.getTotalPrice = function getTotalPrice(order) {
            // Parse orderForm to get missing options keys
            order.options.forEach(function(orderOption) {
                var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                    return formOption.id === orderOption.id;
                });
                orderOption.optionType = optionInfos ? optionInfos.optionType : '';
                orderOption.reference = optionInfos ? optionInfos.reference : '';
                orderOption.prices = optionInfos ? optionInfos.prices : [];
            });

            self.pricesService.setOrderForm(self.orderForm);
            self.pricesService.setOrder(order);
            return self.pricesService.updateTotal();
        };

        self.isMultiDevice = function isMultiDevice(order) {
            var result = false;
            order.options.forEach(function(orderOption) {
                var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                    return formOption.id === orderOption.id;
                });
                if (optionInfos.code === 'MULTI-DEVICE') {
                    result = true;
                }
            });
            return result;
        };

        self.displaySponsorInfos = function displaySponsorInfos(order) {
            if (order.sponsorName !== null) {
                return order.sponsorName;
            }
            else {
                return orderService.getSponsorInfos(order.sponsor).reduce(function(acc, curr, index) {
                    return acc + ' ' + (index % 2 == 1 ? curr + '</li>' : curr);
                }, '<li>');
            }
        };

        // If the package code is the same as the order package code, returns X; returns an empty string otherwise
        self.tickPackage = function tickPackage(packageCode, orderPackageCode) {
            return packageCode === orderPackageCode ? 'X' : '';
        };

        return self;
    }

    ExportWebTillCtrl.$inject = [
        '$scope',
        '$rootScope',
        'reportRoutingService',
        'orderService',
        'userService',
        'marketService',
        'exportService',
        'pricesService'
    ];

    angular.module('app.bdc.reports.exportWebTillCtrl', []).controller('ExportWebTillCtrl', ExportWebTillCtrl);
});
